export default {
    INTRODUCTION: {
      value: 1,
      label: '入门指南',
    },
    MANUAL: {
      value: 2,
      label: '用户手册',
    },
    RHYTHM: {
      value: 3,
      label: 'DATA LIST（音色，节奏）',
    },
    KEYBOARD: {
      value: 4,
      label: '键盘功能/设备连接/软件升级/其他',
    }
  }
  